module.exports = __webpack_public_path__ + "img/file-type-movie-alt.a362b0a4.svg";